import { setupContinueWithEmail } from 'utils/loginAndSignupForms';
import CompanyAutocomplete from '../company-autocomplete/component';

document.addEventListener('DOMContentLoaded', () => {
  // This module is imported from the global application entrypoint, so it runs on
  // every page. The redesigned sign-up page renders the form as React (SignUpCard),
  // which reuses the `new_user` and `continue-with-email` ids but owns its own
  // toggle and autocomplete — binding these legacy helpers on top fights React for
  // control of the same DOM.
  if (document.querySelector('[data-controller="turbo-mount-sign-up-card"]')) {
    return;
  }

  setupContinueWithEmail('new_user');

  const { apiCompanyAutocompleteUri } = document.body.dataset;
  const input = document.querySelectorAll('#user_company_name')[0];
  CompanyAutocomplete(input, apiCompanyAutocompleteUri);
});
